import { type BoxProps, Stack, type StackProps, Typography } from '@mui/material'
import { SettleLogo } from 'settle-ui/components/SettleLogo/SettleLogo'

interface IOnboardingHeaderProps extends Pick<StackProps, 'pb'> {
  title: React.ReactNode
  maxWidth?: number | string
  ignoreDefaultSubtitleLayout?: boolean
  overline?: React.ReactNode
  subtitle?: React.ReactNode
  slots?: {
    logo?: React.ReactNode
  }
  slotProps?: {
    logo?: {
      mb?: BoxProps['mb']
    }
  }
}

export const OnboardingHeader: Settle.FC<IOnboardingHeaderProps> = ({
  slots,
  overline,
  title,
  subtitle,
  maxWidth,
  ignoreDefaultSubtitleLayout,
  slotProps,
  ...props
}) => {
  const { logo } = slots ?? {}

  const renderedSubtitle = ignoreDefaultSubtitleLayout ? (
    subtitle
  ) : (
    <Typography
      sx={{
        textAlign: 'center',
        color: (theme) => theme.tokens.ThemeColorCommonOnSurfaceSecondary,
      }}
    >
      {subtitle}
    </Typography>
  )

  return (
    <Stack
      {...props}
      sx={(theme) => ({
        maxWidth,
        alignItems: 'center',
        gap: theme.spacing(1),
      })}
    >
      {logo ? logo : <SettleLogo mb={2} {...(slotProps?.logo ?? {})} />}
      {overline && (
        <Typography variant="body1" color="onSurfaceSecondary" textAlign="center">
          {overline}
        </Typography>
      )}
      <Typography
        sx={{
          fontSize: '27px',
          fontWeight: 700,
          lineHeight: '32px',
          textAlign: 'center',
          letterSpacing: '0',
        }}
      >
        {title}
      </Typography>
      {renderedSubtitle}
    </Stack>
  )
}
